import {
  Modal,
  Table,
  Progress,
  Statistic,
  Row,
  Col,
  Alert,
  Skeleton,
  Result,
  Button,
  Divider,
} from "antd";
import { useEffect, useReducer, useState } from "react";
import { createUserWithoutMessage } from "@ADMIN";
import { exportExcel } from "@HELPERS";

const initialState = [];
const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_USERS":
      return payload.map((user) => ({
        ...user,
        createStatus: "RUNNING",
      }));
    case "UPDATE_USER_STATUS_SUCCESS":
      return state.map((user) => {
        if (user.email === payload.email) {
          return {
            ...user,
            createStatus: "SUCCESS",
          };
        }
        return user;
      });
    case "UPDATE_USER_STATUS_ERROR":
      return state.map((user) => {
        if (user.email === payload.email) {
          return {
            ...user,
            createStatus: "ERROR",
            errorMessage: payload.errorMessage,
          };
        }
        return user;
      });
    default:
      break;
  }
};

const CreateResultModal = ({ onClose, data, onSuccessAndRemove }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const [waitingCount, setWaitingCount] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allSuccess, setAllSuccess] = useState(false);
  const [allDone, setAllDone] = useState(false);
  const [errorList, setErrorList] = useState([]);

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "25%",
    },
    {
      title: "Durum",
      dataIndex: "createStatus",
      key: "createStatus",
      width: "50%",
      render: (data, record) => {
        switch (data) {
          case "RUNNING":
            return <Skeleton.Input active block shape="round" size="small" />;
          case "SUCCESS":
            return <Progress percent={100} size="small" />;
          case "ERROR":
            return (
              <Alert message={record.errorMessage} type="error" showIcon />
            );
          default:
            return "HATA!";
        }
      },
    },
  ];

  useEffect(() => {
    dispatch({ type: "SET_USERS", payload: data });
  }, [data, dispatch]);

  useEffect(() => {
    if (state) {
      const success = state?.filter((user) => user.createStatus === "SUCCESS");
      const error = state?.filter((user) => user.createStatus === "ERROR");
      const waiting = state?.filter((user) => user.createStatus === "RUNNING");

      if (success.length === data.length) {
        setAllSuccess(true);
      }

      setSuccessCount(success.length);
      setErrorCount(error.length);
      setWaitingCount(waiting.length);
    }
  }, [data, state, dispatch]);

  useEffect(() => {
    if (allDone) {
      const doneUsers = [];
      const errorUsers = [];
      state.forEach((item, index) => {
        if (item.createStatus === "SUCCESS") {
          doneUsers.push(item.email);
        } else {
          errorUsers.push({
            email: item.email,
            errorMessage: item.errorMessage,
          });
        }
      });

      if (typeof onSuccessAndRemove === "function") {
        onSuccessAndRemove(doneUsers);
      }

      if (errorUsers.length > 0) {
        setErrorList(errorUsers);
      }
    }
  }, [allDone, state]);

  const createResolver = (item) => {
    let user = {
      firstName: item.firstName,
      lastName: item.lastName,
      email: item.email,
      password: item.password,
      authorities: item.authorities,
      onlySavedReceiversDeliveries: item.onlySavedReceiversDeliveries,
      status: item.status,
      role: item.role,
      warehouses: item.warehouses,
    };
    return new Promise((resolve) => {
      createUserWithoutMessage(user).then((result) => {
        if (result?.success) {
          resolve({ success: true });
        } else {
          resolve({
            success: false,
            message: result?.response?.data?.error?.msg,
          });
        }
      });
    });
  };

  const createUserDoNextPromise = (index) => {
    createResolver(state[index]).then((result) => {
      if (result.success) {
        dispatch({
          type: "UPDATE_USER_STATUS_SUCCESS",
          payload: { email: state[index].email },
        });
      } else {
        dispatch({
          type: "UPDATE_USER_STATUS_ERROR",
          payload: {
            email: state[index].email,
            errorMessage: result.message,
          },
        });
      }
      index++;
      if (index < state.length) {
        createUserDoNextPromise(index);
      } else {
        setLoading(false);
        setAllDone(true);
      }
    });
  };

  const downloadErrorUsers = () => {
    exportExcel(
      "Hatalı Kullanıcılar",
      [
        { title: "Email", key: "email" },
        { title: "Hata Sebebi", key: "errorMessage" },
      ],
      errorList
    );
  };

  useEffect(() => {
    if (state && state.length > 0 && !mounted) {
      createUserDoNextPromise(0);
      setMounted(true);
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <Modal
      visible
      title="Toplu Kullanıcı Bilgisi Oluşturma Durumu"
      onCancel={() => {
        if (!loading) {
          onClose();
        }
      }}
      width={950}
      footer={null}
    >
      <Row gutter={24}>
        <Col span={8}>
          <Statistic
            title="Başarılı Kullanıcı Bilgisi Sayısı"
            value={successCount}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Hatalı Kullanıcı Bilgisi Sayısı"
            value={errorCount}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Sırada Bekleyen Kullanıcı Bilgisi Sayısı"
            value={waitingCount}
          />
        </Col>
      </Row>
      <div style={{ marginTop: 24 }}>
        {allSuccess ? (
          <>
            <Divider />
            <Result
              status="success"
              title="Kullanıcı Bilgileri Başarıyla Oluşturuldu"
              subTitle={`Kullanıcı Bilgileriniz başarıyla oluşturuldu.`}
              extra={[
                <Button
                  key="buy"
                  onClick={() => {
                    onClose();
                  }}
                >
                  Kapat
                </Button>,
              ]}
            />
          </>
        ) : (
          <>
            <Table
              pagination={false}
              columns={columns}
              dataSource={state}
              scroll={{ y: 400 }}
              bordered
              rowKey="email"
            />
            {errorList?.length > 0 ? (
              <Button
                key="download-errors"
                type="primary"
                danger
                onClick={downloadErrorUsers}
                style={{ marginTop: 16 }}
              >
                Hatalı Kullanıcıları İndir
              </Button>
            ) : null}
          </>
        )}
      </div>
    </Modal>
  );
};

export default CreateResultModal;
